import { render, staticRenderFns } from "./LeaveWindow.vue?vue&type=template&id=19860072&"
import script from "./LeaveWindow.vue?vue&type=script&lang=js&"
export * from "./LeaveWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports